<template>
  <div 
    class="preloading"
    :class="{ cursor: complete }"
    ref="preloading"
    @mousewheel="onScroll"
    @drag="onScroll"
    @click="onScroll"
    @touchend="onScroll"
  >
    <div ref="loading" v-if="!complete">
      <img
        class="loading1 loading"
        :class="{ active: loadingIndex == 0 }"
        alt="loading1"
        ref="loading1"
        src="../../assets/loading/loading01.png"
      />
      <img
        class="loading2 loading"
        :class="{ active: loadingIndex == 1 }"
        alt="loading2"
        ref="loading2"
        src="../../assets/loading/loading02.png"
      />
      <img
        class="loading3 loading"
        :class="{ active: loadingIndex == 2 }"
        alt="loading3"
        ref="loading3"
        src="../../assets/loading/loading03.png"
      />
    </div>
    <div ref="loadcomplete" v-else-if="showIntro" class="intro-wrapper">
      <div class="intro">
        <div class="intro-main">
          <div>
            Samsung
            <br />Upcycle Packaging
          </div>
          <!-- <h1 class="ecopack" ref="ecopack">Eco-Package</h1> -->
        </div>
        <div class="intro-sub secondary-text-color">
          <div>
            {{$t('LandingPage.intro_sub')}}
          </div>
        </div>
      </div>
      <div class="arrow-position">
        <div class="down-arrow">
          <img src="../../assets/icons/downarrow-3.png" alt="downarrow-3" class="downarrow-3" />
          <img src="../../assets/icons/downarrow-2.png" alt="downarrow-2" class="downarrow-2" />
          <img src="../../assets/icons/downarrow-1.png" alt="downarrow-1" class="downarrow-1" />
          <img src="../../assets/icons/arrow-down3.png" class="pc-downarrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax, Linear } from "gsap";
export default {
  props: {
    complete: { type: Boolean, default: () => false },
    onRemoved: { type: Function, default: () => {} },
  },
  data() {
    return {
      loadingIndex: 0,
      loadInterval: undefined,
      originalHeight: document.body.style.height,
      showIntro:true,
    };
  },
    created(){

     if(window.sessionStorage.getItem("introFlag")=='false'){
          this.showIntro=false;
     }

  },
  watch: {
    complete(newVal) {
      // alert(newVal);
      if (newVal) {
        this.$nextTick(() => {
          TweenMax.to(this.$refs.loadcomplete, 0, {
            opacity: 0,
            ease: Linear.ease
            // delay: 0.01
          });
          TweenMax.to(this.$refs.loadcomplete, 0.8, {
            opacity: 1
          });
          
        });
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    document.body.style.height = "100vh";
    document.body.style.overflowY = "hidden";

    if(window.sessionStorage.getItem("introFlag")=='false')
    { 
      TweenMax.to(this.$refs.preloading, 1, {
        display: "none",
        onComplete: this.onRemoved
      });
 
    }

    this.$nextTick(() => {
      this.loadInterval = setInterval(() => {
        this.loadingIndex += 1;
        if (this.loadingIndex == 3) {
          this.loadingIndex = 0;
        }
      }, 1000);
    });
  },
  methods: {
    onScroll() {
      if (!this.complete) {
        return;
      }
      window.scrollTo(0, 1);
      document.body.style.height = this.originalHeight;
      TweenMax.to(this.$refs.preloading, 0.3, {
        yPercent: -100,
        ease: Linear.ease
        // delay: 0.01
      });
      TweenMax.to(this.$refs.preloading, 0.4, {
        display: "none",
        onComplete: this.onRemoved
      });
    }
  },
  destroyed() {
    if (this.loadInterval) {
      clearInterval(this.loadInterval);
      this.loadInterval = null;
    }
  }
};
</script>

<style scoped>
.preloading {
  background-color: black;
  height: 100vh;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
}
.preloading.cursor {
  cursor: pointer;
}
.loading {
  display: none;
}
.loading.active {
  display: block;
}

.loadcomplete {
  animation: fadeIn 1s ease-out;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.intro-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  margin:auto;
}
.intro-main {
  font-size: 36px;
  font-weight: 700;
  text-align: left;
}
.intro-sub {
  margin-top: 26px;
  font-size: 23px;
  font-weight: 700;
  text-align: left;
  width:250px;
  height:50px;
}

.down-arrow {
  width: 30px;
  height: 50px;
  position: relative;
  margin: auto;
}
.down-arrow img {
  position: absolute;
  top: 0;
  left: 0;
}
.down-arrow img.downarrow-3 {
  transform: translateY(0px);
}
.down-arrow img.downarrow-2 {
  transform: translateY(13px);
}
.down-arrow img.downarrow-1 {
  transform: translateY(26px);
}
.arrow-position {
  /* height: vh; */
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: auto;
}
.intro {
  margin-top: auto;
}
.pc-downarrow {
  display: none;
}

@media (min-width: 768px) {
  .down-arrow img.downarrow-3 {
    display: none;
  }
  .down-arrow img.downarrow-2 {
    display: none;
  }
  .down-arrow img.downarrow-1 {
    display: none;
  }
  .pc-downarrow {
    position: static;
    display: inline;
  }
  .down-arrow {
    width: 60px;
    height: 84px;
    /* display: flex;
    justify-content: center; */
    margin: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  .down-arrow img {
    margin: auto;
    position: static;
  }
  .intro-main {
    font-size: 60px;
    text-align: left;
  }
  .intro-sub {
    font-size: 30px;
    margin-top: 45px;
    width:450px;

  }
  .arrow-position {
    height: 84px;
    margin: auto;
    margin-bottom: 20px;
    width: 100%;
    /* position: absolute; */
    bottom: 0;
  }
}
</style>
